import { Stagger, StaggerItem, FadeUp, MaskReveal } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import RootLine from "@/components/RootLine";

export const NEURO_CAPACIDADES = [
  "Atenção",
  "Memória",
  "Linguagem",
  "Raciocínio",
  "Funções Executivas",
  "Aprendizagem",
  "Funcionamento Intelectual",
  "Aspectos Emocionais",
  "Aspectos Comportamentais",
];

const NeuroHighlight = () => (
  <section data-testid="neuro-highlight-section" className="relative overflow-hidden bg-raiz-900 py-20 text-raiz-50 lg:py-32">
    <div
      aria-hidden="true"
      className="absolute -left-48 -top-48 h-[480px] w-[480px] rounded-full border border-raiz-50/10"
    />
    <div
      aria-hidden="true"
      className="absolute -bottom-64 -right-40 h-[560px] w-[560px] rounded-full border border-raiz-50/10"
    />
    <div className="container-x relative grid items-center gap-14 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <FadeUp>
          <p className="eyebrow text-raiz-200" data-testid="neuro-eyebrow">03 — Neuropsicologia</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2 className="mt-5 max-w-xl font-serif text-3xl font-light leading-[1.12] tracking-tight text-raiz-50 sm:text-4xl lg:text-5xl" data-testid="neuro-title">
            Compreender o funcionamento também ajuda a compreender a pessoa.
          </h2>
        </FadeUp>
        <FadeUp delay={0.16}>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-raiz-100/75 md:text-lg">
            A avaliação neuropsicológica é um processo clínico estruturado que busca compreender diferentes aspectos do funcionamento cognitivo, emocional e comportamental, considerando a história, o contexto e as particularidades de cada pessoa.
          </p>
        </FadeUp>
        <Stagger className="mt-10 flex flex-wrap gap-2.5" gap={0.05}>
          {NEURO_CAPACIDADES.map((c) => (
            <StaggerItem key={c}>
              <span className="inline-block rounded-full border border-raiz-50/25 px-4 py-2 text-[13px] tracking-wide text-raiz-100 transition-colors duration-300 hover:border-raiz-200 hover:bg-raiz-50/10">
                {c}
              </span>
            </StaggerItem>
          ))}
        </Stagger>
        <FadeUp delay={0.2} className="mt-10">
          <ArrowButton to="/neuropsicologia" variant="light" testId="neuro-cta-button">
            Conhecer a Neuropsicologia
          </ArrowButton>
        </FadeUp>
      </div>
      <div className="relative lg:col-span-5">
        <MaskReveal delay={0.2} className="relative overflow-hidden rounded-[2rem]">
          <img
            src="/assets/sabrina-neuro.jpg"
            alt="Sabrina Mota, neuropsicóloga, em seu consultório"
            data-testid="neuro-photo"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
            width="1200"
            height="1500"
          />
        </MaskReveal>
        <div aria-hidden="true" className="absolute -bottom-6 -right-4 -z-0 h-full w-full rounded-[2rem] border border-raiz-50/15" />
      </div>
    </div>
    <RootLine light className="relative mt-16 h-16 opacity-60 lg:mt-24" />
  </section>
);

export default NeuroHighlight;
